import { render, staticRenderFns } from "./yardim.vue?vue&type=template&id=339003e4&scoped=true&"
import script from "./yardim.vue?vue&type=script&lang=js&"
export * from "./yardim.vue?vue&type=script&lang=js&"
import style0 from "./yardim.vue?vue&type=style&index=0&id=339003e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339003e4",
  null
  
)

export default component.exports